import { Box } from '@mui/material';
import { Theme, styled } from '@mui/material/styles';

type DrawerHeaderStyledProps = {
  open: boolean;
  theme: Theme;
};
const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }: DrawerHeaderStyledProps) => ({
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
    justifyContent: open ? 'flex-start' : 'center',
    paddingLeft: theme.spacing(open ? 3 : 0)
  })
);

export { DrawerHeaderStyled };
export type { DrawerHeaderStyledProps };
